import actions from '../../../redux/game/actions';
import { eGameState } from '../../../redux/game/reducer';
import { store } from '../../../index';

export default class ControllerBaseBehaviour {
  constructor() {
    this.freeBetsController = window.OPWrapperService.freeBetsController;
  }
  updateFreeBets() {
    const state = store.getState().game;
    this.freeBetsController.updateTotalWin();
    if (!state.freespinsEnabled) {
      this.freeBetsController.show();
      window.OPWrapperService.realityCheck.blockedRealityCheck = false;
    }
    if (
      (this.freeBetsController.isFirstFreeBet || this.freeBetsController.isLastFreeBet || window.OPWrapperService.realityCheck.blockedGame)
      && state.autospin
    ) {
      store.dispatch(actions.stopAutospin());
      store.dispatch(actions.setGameState(eGameState.EGS_STOP_AUTOSPIN));
    }
  }
}
